import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, withStyles, createStyles, Theme, Typography } from '@material-ui/core';
import moment from 'moment';
import GhaPickupStatusAwb from '../../models/GhaPickupStatusAwb';

interface OrderSelectionPopupProps {
  orders: Array<GhaPickupStatusAwb>;
  open: boolean;
  onClose: () => void;
  onSelect: (order: any) => void;
  classes: any;
};  

// Custom styles
const styles = (theme: Theme) => createStyles({
  dialog: {
    width: '600px', // Increase width
    padding: theme.spacing(2),
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  listItemText: {
    color: theme.palette.text.primary,
  },
  listItemSecondaryText: {
    color: theme.palette.text.secondary,
  },
  cancelButton: {
    color: theme.palette.secondary.main,
  },
  boldText: {
    fontWeight: 'bold',
  },
});

const orderSelectionPopup = (props: OrderSelectionPopupProps) => {

  const { orders, open, onClose, classes } = props;

  function handleOrderSelect(order: any) {
    props.onSelect(order);
  }

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>Select an Order</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <List>
          {orders.map((order: any) => (
            <ListItem button key={order.number} onClick={() => handleOrderSelect(order)} className={classes.listItem}>
           <ListItemText 
                primary={<Typography className={classes.boldText}>{`Order ${order.number}`}</Typography>}
                secondary={
                  <>
                    <span className={classes.listItemSecondaryText}>{`Pickup Date: ${moment(order.pickup_date).format('DDMMMYY').toUpperCase()}`}</span><br/>
                    <span className={classes.listItemSecondaryText}>{`Pickup Time: ${order.pickup_time}`}</span><br/>
                    <span className={classes.listItemSecondaryText}>{`Trucking Company: ${order.delivery_company_name}`}</span>
                  </>
                }
                classes={{ primary: classes.listItemText, secondary: classes.listItemSecondaryText }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} className={classes.cancelButton}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(orderSelectionPopup);
